"use strict";

var _regeneratorRuntime = require("/home/travis/build/ulabox/boksa/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.takeEveryAddToCart = exports.channelAddToCartByProduct = exports.addToCartCorutine = exports.LAST_TASK = exports.INITIAL_CHANNEL_BUFFER_SIZE = void 0;

var _reduxSaga = require("redux-saga");

var _array = require("lodash/array");

var _object = require("lodash/object");

var _collection = require("lodash/collection");

var _effects = require("redux-saga/effects");

var _api = require("@modules/api");

var _snackbar = require("@modules/snackbar");

var _getRequestPayload = _interopRequireDefault(require("./utils/getRequestPayload"));

var vault = _interopRequireWildcard(require("./utils/vault"));

var _state = require("./state");

var _actions = require("./actions");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var INITIAL_CHANNEL_BUFFER_SIZE = 15;
exports.INITIAL_CHANNEL_BUFFER_SIZE = INITIAL_CHANNEL_BUFFER_SIZE;
var LAST_TASK = 1;
exports.LAST_TASK = LAST_TASK;

var addToCartCorutine =
/*#__PURE__*/
_regeneratorRuntime.mark(function addToCartCorutine(action, buffer, close) {
  var _ref, _ref2, response, body, payload, isLastRunningTask, isAllEmpty;

  return _regeneratorRuntime.wrap(function addToCartCorutine$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return _effects.call.apply(void 0, _toConsumableArray((0, _api.apiGetRequestParams)({
            route: "/carts/products",
            params: (0, _api.apiMakeRequestParams)((0, _getRequestPayload.default)(action), {}, true)
          })));

        case 3:
          _ref = _context.sent;
          _ref2 = _slicedToArray(_ref, 2);
          response = _ref2[0];
          body = _ref2[1];

          if (!(response.ok && !body.error)) {
            _context.next = 19;
            break;
          }

          if (!buffer.isEmpty()) {
            _context.next = 17;
            break;
          }

          payload = (0, _state.transformCartSimple)((0, _object.get)(body, 'data'));
          isLastRunningTask = vault.getRunningTasks().length <= LAST_TASK;
          isAllEmpty = (0, _collection.every)(vault.getChannels(), function (channel) {
            return channel.buffer.isEmpty();
          });
          _context.next = 14;
          return (0, _effects.put)((0, _actions.addToCartSuccess)(payload, action.productID));

        case 14:
          if (!(isAllEmpty && isLastRunningTask)) {
            _context.next = 17;
            break;
          }

          _context.next = 17;
          return (0, _effects.put)((0, _actions.fetchCart)(payload.id));

        case 17:
          _context.next = 23;
          break;

        case 19:
          _context.next = 21;
          return (0, _effects.put)(_snackbar.snackbarActions.show({
            message: body.error.literal
          }));

        case 21:
          _context.next = 23;
          return (0, _effects.put)((0, _actions.fetchCart)((0, _object.get)(body, 'data.id') || action.cartID));

        case 23:
          _context.next = 28;
          break;

        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);

        case 28:
          _context.prev = 28;
          buffer.isEmpty() && close();
          return _context.finish(28);

        case 31:
        case "end":
          return _context.stop();
      }
    }
  }, addToCartCorutine, this, [[0, 25, 28, 31]]);
});

exports.addToCartCorutine = addToCartCorutine;

var channelAddToCartByProduct =
/*#__PURE__*/
_regeneratorRuntime.mark(function channelAddToCartByProduct(_ref3, close) {
  var channel, buffer, firstAction, stack, actions, lastAction, addToCartTask;
  return _regeneratorRuntime.wrap(function channelAddToCartByProduct$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          channel = _ref3.channel, buffer = _ref3.buffer;

        case 1:
          if (!true) {
            _context2.next = 19;
            break;
          }

          _context2.next = 4;
          return (0, _effects.take)(channel);

        case 4:
          firstAction = _context2.sent;
          _context2.next = 7;
          return (0, _effects.flush)(channel);

        case 7:
          stack = _context2.sent;
          actions = [firstAction].concat(_toConsumableArray(stack));
          lastAction = (0, _array.last)(actions);
          _context2.next = 12;
          return (0, _effects.fork)(addToCartCorutine, lastAction, buffer, close);

        case 12:
          addToCartTask = _context2.sent;
          _context2.next = 15;
          return vault.addTask(addToCartTask);

        case 15:
          _context2.next = 17;
          return (0, _effects.join)(addToCartTask);

        case 17:
          _context2.next = 1;
          break;

        case 19:
        case "end":
          return _context2.stop();
      }
    }
  }, channelAddToCartByProduct, this);
});

exports.channelAddToCartByProduct = channelAddToCartByProduct;

var takeEveryAddToCart =
/*#__PURE__*/
_regeneratorRuntime.mark(function takeEveryAddToCart() {
  var action, productID, CHANNEL_ACTION, buffer, channel;
  return _regeneratorRuntime.wrap(function takeEveryAddToCart$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!true) {
            _context3.next = 18;
            break;
          }

          _context3.next = 3;
          return (0, _effects.take)(_actions.ADD_TO_CART);

        case 3:
          action = _context3.sent;
          productID = action.productID;
          CHANNEL_ACTION = "".concat(_actions.ADD_TO_CART, "_").concat(productID);

          if (vault.getChannel(productID)) {
            _context3.next = 14;
            break;
          }

          buffer = _reduxSaga.buffers.expanding(INITIAL_CHANNEL_BUFFER_SIZE);
          _context3.next = 10;
          return (0, _effects.actionChannel)(CHANNEL_ACTION, buffer);

        case 10:
          channel = _context3.sent;
          vault.setChannel(productID, channel, buffer);
          _context3.next = 14;
          return (0, _effects.fork)(channelAddToCartByProduct, vault.getChannel(productID), vault.closeChannel(productID));

        case 14:
          _context3.next = 16;
          return (0, _effects.put)(_objectSpread({}, action, {
            type: CHANNEL_ACTION
          }));

        case 16:
          _context3.next = 0;
          break;

        case 18:
        case "end":
          return _context3.stop();
      }
    }
  }, takeEveryAddToCart, this);
});

exports.takeEveryAddToCart = takeEveryAddToCart;

var cart =
/*#__PURE__*/
_regeneratorRuntime.mark(function cart() {
  return _regeneratorRuntime.wrap(function cart$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.fork)(takeEveryAddToCart);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, cart, this);
});

var _default = cart;
exports.default = _default;